import { render, staticRenderFns } from "./courseManageModal.vue?vue&type=template&id=da2b0bd4&"
import script from "./courseManageModal.vue?vue&type=script&lang=js&"
export * from "./courseManageModal.vue?vue&type=script&lang=js&"
import style0 from "./courseManageModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports